<template>
  <div class="calculator">
    <div ref="topAnchor"></div>
    <h1>卷軸計算機</h1>
    
    <div class="calculator-container">
      <!-- 卷軸選擇區域 -->
      <div class="scrolls-section" ref="scrollsSection">
        <div class="scroll-group">
          <div class="scroll-type">
            <h2>武器卷軸</h2>
            <div class="scroll-item">
              <h3>武器攻擊力卷軸</h3>
              <input 
                type="number" 
                v-model.number="scrollLevels.weaponAtk" 
                min="0"
                placeholder="請輸入數量"
              >
            </div>
            <div class="scroll-item">
              <h3>武器魔力卷軸</h3>
              <input 
                type="number" 
                v-model.number="scrollLevels.weaponMAtk" 
                min="0"
                placeholder="請輸入數量"
              >
            </div>
          </div>

          <div class="scroll-type">
            <h2>防具卷軸</h2>
            <div class="scroll-item">
              <h3>防具力量卷軸</h3>
              <input 
                type="number" 
                v-model.number="scrollLevels.armorStr" 
                min="0"
                placeholder="請輸入數量"
              >
            </div>
            <div class="scroll-item">
              <h3>防具敏捷卷軸</h3>
              <input 
                type="number" 
                v-model.number="scrollLevels.armorDex" 
                min="0"
                placeholder="請輸入數量"
              >
            </div>
            <div class="scroll-item">
              <h3>防具智力卷軸</h3>
              <input 
                type="number" 
                v-model.number="scrollLevels.armorInt" 
                min="0"
                placeholder="請輸入數量"
              >
            </div>
            <div class="scroll-item">
              <h3>防具幸運卷軸</h3>
              <input 
                type="number" 
                v-model.number="scrollLevels.armorLuk" 
                min="0"
                placeholder="請輸入數量"
              >
            </div>
          </div>
        </div>
        <div class="confirm-section">
          <button @click="calculate" class="confirm-btn">確認計算</button>
          <button @click="resetAll" class="reset-btn">重設</button>
        </div>
      </div>

      <!-- 總計區域 -->
      <div class="total-section" ref="totalSection">
        <h3>總計</h3>
        <div class="total-content">
          <div class="total-item">
            <span>武器攻擊力：</span>
            <span>{{ totalStats.weaponAtk }}</span>
          </div>
          <div class="total-item">
            <span>武器魔力：</span>
            <span>{{ totalStats.weaponMAtk }}</span>
          </div>
          <div class="total-item">
            <span>力量：</span>
            <span>{{ totalStats.str }}</span>
          </div>
          <div class="total-item">
            <span>敏捷：</span>
            <span>{{ totalStats.dex }}</span>
          </div>
          <div class="total-item">
            <span>智力：</span>
            <span>{{ totalStats.int }}</span>
          </div>
          <div class="total-item">
            <span>幸運：</span>
            <span>{{ totalStats.luk }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ScrollCalculator',
  data() {
    return {
      scrollLevels: {
        weaponAtk: null,
        weaponMAtk: null,
        armorStr: null,
        armorDex: null,
        armorInt: null,
        armorLuk: null
      },
      totalStats: {
        weaponAtk: 0,
        weaponMAtk: 0,
        str: 0,
        dex: 0,
        int: 0,
        luk: 0
      }
    }
  },
  methods: {
    calculate() {
      // 計算武器攻擊力
      this.totalStats.weaponAtk = (this.scrollLevels.weaponAtk || 0) * 5
      
      // 計算武器魔力
      this.totalStats.weaponMAtk = (this.scrollLevels.weaponMAtk || 0) * 5
      
      // 計算力量
      this.totalStats.str = (this.scrollLevels.armorStr || 0) * 3
      
      // 計算敏捷
      this.totalStats.dex = (this.scrollLevels.armorDex || 0) * 3
      
      // 計算智力
      this.totalStats.int = (this.scrollLevels.armorInt || 0) * 3
      
      // 計算幸運
      this.totalStats.luk = (this.scrollLevels.armorLuk || 0) * 3
      
      // 計算完成後滾動到總計區域
      this.$nextTick(() => {
        this.scrollToTotal()
      })
    },
    resetAll() {
      // 重設所有數值
      Object.keys(this.scrollLevels).forEach(key => {
        this.scrollLevels[key] = null
      })
      // 重設計算結果
      Object.keys(this.totalStats).forEach(key => {
        this.totalStats[key] = 0
      })
      // 重設後滾動到頁面最上方
      this.$router.replace(this.$route.path)
    },
    scrollToTotal() {
      const totalSection = this.$refs.totalSection
      if (totalSection) {
        totalSection.scrollIntoView({ 
          behavior: 'smooth',
          block: 'start'
        })
      }
    },
    scrollToInput() {
      const scrollsSection = this.$refs.scrollsSection
      if (scrollsSection) {
        scrollsSection.scrollIntoView({ 
          behavior: 'smooth',
          block: 'start'
        })
      }
    }
  }
}
</script>

<style scoped>
.calculator {
  padding: 1.5rem 0;
}

.calculator h1 {
  font-size: 1.8rem;
  text-align: center;
  margin-bottom: 1.5rem;
  color: var(--text-color);
}

.calculator-container {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  margin-top: 1.5rem;
  max-width: 900px;
  margin-left: auto;
  margin-right: auto;
}

.scrolls-section {
  width: 100%;
}

.scroll-group {
  background: white;
  padding: 1.2rem;
  border-radius: 12px;
  box-shadow: var(--card-shadow);
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 1.2rem;
}

.scroll-type {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.scroll-type h2 {
  color: var(--primary-color);
  margin-bottom: 0.5rem;
  font-size: 1.1rem;
}

.scroll-item {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-bottom: 1rem;
}

.scroll-item:last-child {
  margin-bottom: 0;
}

.scroll-item h3 {
  color: var(--text-color);
  margin-bottom: 0.25rem;
  font-size: 0.9rem;
}

.scroll-item input {
  width: 100%;
  padding: 0.4rem;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 0.85rem;
  font-family: inherit;
  transition: border-color var(--transition-speed) ease;
}

.scroll-item input:focus {
  outline: none;
  border-color: var(--primary-color);
  box-shadow: 0 0 0 2px rgba(74, 144, 226, 0.2);
}

.confirm-section {
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-top: 1.5rem;
}

.confirm-btn {
  padding: 0.6rem 2rem;
  background-color: var(--primary-color);
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 1rem;
  transition: all var(--transition-speed) ease;
  font-weight: 500;
}

.reset-btn {
  padding: 0.6rem 2rem;
  background-color: #dc3545;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 1rem;
  transition: all var(--transition-speed) ease;
  font-weight: 500;
}

.reset-btn:hover {
  background-color: #c82333;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.confirm-btn:hover {
  background-color: var(--nav-hover);
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.total-section {
  background: white;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: var(--card-shadow);
  scroll-margin-top: 2rem;
}

.total-section h3 {
  color: var(--primary-color);
  margin-bottom: 1.5rem;
}

.total-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
}

.total-item {
  display: flex;
  justify-content: space-between;
  padding: 0.5rem;
  border-bottom: 1px solid #eee;
}

.total-item:last-child {
  border-bottom: none;
}

@media (max-width: 768px) {
  .scroll-group {
    grid-template-columns: 1fr;
    padding: 1rem;
  }
  
  .calculator-container {
    padding: 0 1rem;
  }
}
</style> 